import Vue from 'vue'
import BuiltOptions from './BuiltOptions.vue'
import store from '@/store'
import config from '@/mixins/componentConfiguration'
import commonConfig from '@/mixins/commonMixin'

window.vm = new Vue({
  store,
  mixins: [commonConfig(Vue), config(Vue)],
  render: h => h(BuiltOptions)
}).$mount('#builtoptions')
